import { Link } from 'react-router-dom';
import styles from './Account.module.css';
import { SignOutButton, useUser } from "@clerk/clerk-react";
export default function AccountPage() {
    const { user } = useUser();
  return (
    <div className={styles.container}>
      <div className={styles.profileSection}>
        <img src={user ? user.imageUrl : "Profile.svg"} alt="Profile" className={styles.avatar} />
        <h1 className={styles.name}>Omer Bashir</h1>
      </div>

      {/* 1. Quick Info Card */}
      <div className={styles.statsCard}>
        <div className={styles.statItem}>
          <span>Monthly Budget</span>
          <strong>$2,500.00</strong>
        </div>
        <div className={styles.statItem}>
          <span>Currency</span>
          <strong>USD ($)</strong>
        </div>
      </div>

      <nav className={styles.menu}>

        <Link to={"/soon"} className={styles.menuLink}>
          Manage Categories <span className={styles.arrow}>❯</span>
        </Link>

        <Link to={"/soon"} className={styles.menuLink}>
          Export Date (CSV) <span className={styles.arrow}>❯</span>
        </Link>
        
        <Link to={"/Inbox"} className={styles.menuLink}>
          Notifications <span className={styles.arrow}>❯</span>
        </Link>

        <Link to={"/soon"} className={styles.menuLink}>
          App Settings <span className={styles.arrow}>❯</span>
        </Link>
        
        <div className={`${styles.MenuItem} ${styles.Logout}`}>
            <SignOutButton>
                <span>Logout</span>
            </SignOutButton>
        </div>
      </nav>
    </div>
  );
}